"use client";

import { formatTestId } from "@nimble/ts-formatters/format-test-ids";
import { LucideIcon } from "lucide-react";
import * as React from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { schoolTagsTestIds } from "@/lib/data-test-ids/schools.data-test-ids";
import { cn } from "@/lib/utils";

type SchoolTagProps = {
  IconComponent?: LucideIcon;
  title: string;
  tooltip: string;
  className?: string;
  dataTestid?: string;
};

export default function SchoolTag({
  IconComponent,
  title,
  className,
  tooltip,
  dataTestid,
}: SchoolTagProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            `inline-flex items-center gap-1 text-[10px] sm:text-xs font-semibold text-primary`,
            className,
          )}
          data-testid={
            dataTestid ||
            `${schoolTagsTestIds.SCHOOL_TAG_ITEM}-${formatTestId(title)}`
          }
        >
          {IconComponent && <IconComponent className="w-3 h-3" />}
          {title}
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{tooltip}</p>
      </TooltipContent>
    </Tooltip>
  );
}
